export default "__VITE_ASSET__1b66f927__"